import Axios from "axios";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Button, Card, Col, Form, InputGroup, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Modal from "react-bootstrap/Modal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { DataTablePagination } from "../utils/dataTablePagination";
import {
  getApiResponseMessage,
  getApiErrorMessage,
} from "../../utils/apiMessageHelper";

import companyAvatar from "../../assets/images/user/company-avatar.png";

// Contexts
import { useNotification } from "../../contexts/NotificationContext";
import useClientsStore from "../../stores/useClientsStore";

export const ListClients = () => {
  //> Constants
  const { t } = useTranslation();
  // Contexts
  const { notify } = useNotification();
  const refreshClients = useClientsStore((state) => state.refreshClients);

  const columns = [
    {
      Header: " ",
      columns: [
        {
          Header: "",
          accessor: "idw",
          Cell: (props) => {
            const avatarSrc = props.cell.row.original.image || companyAvatar;
            return (
              <img
                class="rounded-circle table-profile-icon"
                src={avatarSrc}
                alt="activity-user"
              ></img>
            );
          },
        },
        { Header: "ID", accessor: "id" },
        { Header: t("clients.nameLabel"), accessor: "name" },
        {
          Header: t("clients.conditionLabel"),
          accessor: "status",
          Cell: (props) => {
            return props.cell.row.original.status === 1 ? (
              <span className="label theme-bg text-white f-12 status-icon">
                {t("clients.activeStatus")}
              </span>
            ) : (
              <span className="label theme-bg2 text-white f-12 status-icon">
                {t("clients.inactiveStatus")}
              </span>
            );
          },
        },
        // {
        //   Header: "Detalle",
        //   accessor: "detalle",
        //   Cell: (props) => {
        //     return (
        //       <FaEye
        //         className="fa-table-icon"
        //         onClick={() => history(`/client/${props.cell.row.original.id}`)}
        //       />
        //     );
        //   },
        // },
        // {
        //     Header: 'Seleccionar', accessor: 'select',
        //     Cell: props => {
        //         return (<FaCheckDouble className="fa-table-icon" onClick={()=>setCurrentClient(props.cell.row.original)}/>);
        //     }
        // },
      ],
    },
  ];

  //> States
  const [data, setData] = useState([]);
  const [rows, setRows] = useState([]);
  const [currentClient, setCurrentClient] = useState([]);
  const [validated, setValidated] = useState(false);

  const [showNewClient, setShowNewClient] = useState(false);
  const [newClient, setNewClient] = useState([]);
  const handleCloseNewClient = () => setShowNewClient(false);
  const handleShowNewClient = () => setShowNewClient(true);

  const [showEditClient, setShowEditClient] = useState(false);
  const handleCloseEditClient = () => setShowEditClient(false);
  const handleShowEditClient = () => {
    setShowEditClient(true);
    setClientActiveEditSwitch(currentClient.status === 1 ? true : false);
  };

  const [clientActiveSwitch, setClientActiveSwitch] = useState(true);
  const toggleClientActiveHandler = () => {
    setClientActiveSwitch((prevState) => !prevState);
  };

  const [clientActiveEditSwitch, setClientActiveEditSwitch] = useState(true);
  const toggleClientActiveEditHandler = () => {
    setClientActiveEditSwitch((prevState) => !prevState);
  };

  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const handleCloseDeleteConfirm = () => setShowDeleteConfirm(false);
  const handleShowDeleteConfirm = () => setShowDeleteConfirm(true);

  //> api calls
  const getClients = useCallback(async () => {
    try {
      const res = await Axios.get(
        `${process.env.REACT_APP_API_URL}/api/v1/Client/list`,
      );

      if (res.data.length === 0) {
        setData((prev) => ({
          ...prev,
          message: t("clients.noClientsMessage"),
        }));
      }
      setRows(res.data.responseObject);
    } catch (e) {
      setData((prev) => ({
        ...prev,
        message: e.message,
      }));
    }
  }, [t]);

  async function deleteCliente() {
    try {
      const res = await Axios.delete(
        `${process.env.REACT_APP_API_URL}/api/v1/Client/${currentClient.id}`,
      );

      if (res.status === 200) {
        const message =
          getApiResponseMessage(res) || t("clients.clientDeletedSuccess");
        notify(message, { type: "success" });
      }
    } catch (e) {
      const errorMessage = getApiErrorMessage(e);
      notify(errorMessage, { type: "error" });
    } finally {
      getClients();
      refreshClients();
      setCurrentClient(null);
      handleCloseDeleteConfirm();
    }
  }

  const handleNewClientSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      setValidated(false);

      try {
        newClient.status = clientActiveSwitch ? 1 : 0;
        const res = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/v1/Client`,
          newClient,
        );

        if (res.status === 200) {
          const message =
            getApiResponseMessage(res) || t("clients.clientAddedSuccess");
          notify(message, { type: "success" });
        }
      } catch (e) {
        const errorMessage =
          getApiErrorMessage(e) || t("clients.clientAddError");
        notify(errorMessage, { type: "error" });
      } finally {
        setShowNewClient(false);
        getClients();
        refreshClients();
        setNewClient(null);
        setClientActiveSwitch(true);
      }
    }
  };

  const handleEditClientSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      setValidated(false);

      try {
        currentClient.status = clientActiveEditSwitch ? 1 : 0;
        const res = await Axios.put(
          `${process.env.REACT_APP_API_URL}/api/v1/Client/${currentClient.id}`,
          currentClient,
        );

        if (res.status === 200) {
          const message =
            getApiResponseMessage(res) || t("clients.clientModifiedSuccess");
          notify(message, { type: "success" });
        }
      } catch (e) {
        const errorMessage =
          getApiErrorMessage(e) || t("clients.clientModifyError");
        notify(errorMessage, { type: "error" });
      } finally {
        setShowEditClient(false);
        getClients();
        refreshClients();
        setCurrentClient(null);
        setClientActiveSwitch(true);
      }
    }
  };

  const handleNewClientChange = (object) => {
    const { name, value } = object.target;
    setNewClient((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleEditClientChange = (object) => {
    const { name, value } = object.target;
    setCurrentClient((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const fileInputRef = useRef(null);

  const handleFileRead = async (event) => {
    const fileInput = fileInputRef.current;
    const file = fileInput.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;

        setNewClient((prev) => ({
          ...prev,
          image: base64String,
        }));

        setCurrentClient((prev) => ({
          ...prev,
          image: base64String,
        }));
      };

      reader.readAsDataURL(file);
    }
  };

  //> lifecycles
  useEffect(() => {
    getClients();
  }, [getClients]);

  return (
    <Container>
      <Row>
        <div>
          <Button id="btnLarge" variant="primary" onClick={handleShowNewClient}>
            {t("common.add")}
          </Button>
        </div>
      </Row>
      <Row>
        <Col xs={12} md={8}>
          {rows.length === 0 ? (
            <div className="no-data">{data?.message}</div>
          ) : (
            <DataTablePagination
              columns={columns}
              data={rows}
              onRowClick={(selectedRow) => setCurrentClient(selectedRow)}
              hiddenColumns={["id"]}
            />
          )}
        </Col>
        <Col xs={12} md={4}>
          <Card>
            <Card.Body className="p-0">
              <div>
                <div className="text-center project-main">
                  <img
                    style={{ width: "100px", height: "100px" }}
                    className="img-fluid rounded-circle"
                    src={currentClient?.image || companyAvatar}
                    alt="dashboard-user"
                  />
                  {/* Name */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.nameLabel")}:</span>
                    </div>
                    <div className="col-8">
                      <h6>{currentClient?.name}</h6>
                    </div>
                  </div>
                  {/* Email */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.emailLabel")}:</span>
                    </div>
                    <div className="col-8">
                      <h6>{currentClient?.email}</h6>
                    </div>
                  </div>
                  {/* Phone */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.phoneLabel")}:</span>
                    </div>
                    <div className="col-8">
                      <h6>{currentClient?.phoneNumber}</h6>
                    </div>
                  </div>
                  {/* Country */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.countryLabel")}:</span>
                    </div>
                    <div className="col-8">
                      <h6>{currentClient?.country}</h6>
                    </div>
                  </div>
                  {/* State */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.stateLabel")}:</span>
                    </div>
                    <div className="col-8">
                      <h6>{currentClient?.state}</h6>
                    </div>
                  </div>
                  {/* Address */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.addressLabel")}:</span>
                    </div>
                    <div className="col-8">
                      <h6>{currentClient?.address}</h6>
                    </div>
                  </div>
                  {/* Status */}
                  <div className="row m-t-30">
                    <div className="col-4">
                      <span>{t("clients.conditionLabel")}:</span>
                    </div>
                    <div
                      className="col-8"
                      style={{
                        visibility:
                          currentClient?.id !== null ? "visible" : "hidden",
                      }}
                    >
                      {currentClient?.status === 1 ? (
                        <span className="label theme-bg text-white f-12 status-icon">
                          {t("clients.activeStatus")}
                        </span>
                      ) : (
                        <span className="label theme-bg2 text-white f-12 status-icon">
                          {t("clients.inactiveStatus")}
                        </span>
                      )}
                    </div>
                  </div>
                  <div
                    className="row m-t-30"
                    style={{
                      visibility:
                        currentClient?.id !== null ? "visible" : "hidden",
                    }}
                  >
                    <div className="col-6 p-r-0">
                      <Link
                        className="btn btn-primary  text-uppercase btn-block"
                        onClick={handleShowEditClient}
                      >
                        {t("common.edit")}
                      </Link>
                    </div>
                    <div className="col-6">
                      <Link
                        onClick={handleShowDeleteConfirm}
                        className="btn text-uppercase border btn-block btn-outline-danger"
                      >
                        {t("common.delete")}
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="border-top" />
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* <!-- Modal create new client--> */}
      <Modal show={showNewClient} onHide={handleCloseNewClient}>
        <Form
          className="addForm"
          onSubmit={handleNewClientSubmit}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("clients.addNewClientModal")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="justify-content-md-center">
              {/* Name */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.nameLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={3}
                  autoFocus
                  type="text"
                  name="name"
                  value={newClient?.name || ""}
                  placeholder={t("clients.nameLabel")}
                  onChange={handleNewClientChange}
                />
              </InputGroup>
              {/* Email */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.emailLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={2}
                  autoFocus
                  type="email"
                  name="email"
                  value={newClient?.email || ""}
                  placeholder={t("clients.emailLabel")}
                  onChange={handleNewClientChange}
                />
              </InputGroup>
              {/* Phone Number */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.phoneLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={5}
                  autoFocus
                  autoComplete="off"
                  type="text"
                  name="phoneNumber"
                  value={newClient?.phoneNumber || ""}
                  placeholder={t("clients.phoneLabel")}
                  onChange={handleNewClientChange}
                />
              </InputGroup>
              {/* Country */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.countryLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  autoFocus
                  type="text"
                  name="country"
                  value={newClient?.country || ""}
                  placeholder={t("clients.countryLabel")}
                  onChange={handleNewClientChange}
                />
              </InputGroup>
              {/* State */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.stateLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  autoFocus
                  type="text"
                  name="state"
                  value={newClient?.state || ""}
                  placeholder={t("clients.stateLabel")}
                  onChange={handleNewClientChange}
                />
              </InputGroup>
              {/* Address */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.addressLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  autoFocus
                  type="text"
                  name="address"
                  value={newClient?.address || ""}
                  placeholder={t("clients.addressLabel")}
                  onChange={handleNewClientChange}
                />
              </InputGroup>

              {/* Image */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.imageLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={3}
                  autoFocus
                  type="file"
                  name="image"
                  ref={fileInputRef}
                  placeholder={t("clients.imageLabel")}
                  onChange={handleFileRead}
                />
              </InputGroup>
              {/* Status */}
              <Form.Group>
                <Form.Label>{t("clients.statusLabel")}</Form.Label>
                <div className="switch d-inline m-r-10">
                  <Form.Control
                    type="checkbox"
                    id="checked-default"
                    defaultChecked={clientActiveSwitch}
                    onChange={toggleClientActiveHandler}
                  />
                  <Form.Label htmlFor="checked-default" className="cr" />
                </div>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseNewClient}>
              {t("common.close")}
            </Button>
            <Button variant="primary" type="submit">
              {t("common.save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* <!-- Modal create Edit client--> */}
      <Modal show={showEditClient} onHide={handleCloseEditClient}>
        <Form
          className="addForm"
          onSubmit={handleEditClientSubmit}
          noValidate
          validated={validated}
        >
          <Modal.Header closeButton>
            <Modal.Title>{t("clients.editClientModal")}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className="justify-content-md-center">
              {/* Name */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.nameLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={3}
                  autoFocus
                  type="text"
                  name="name"
                  value={currentClient?.name || ""}
                  placeholder={t("clients.nameLabel")}
                  onChange={handleEditClientChange}
                />
              </InputGroup>
              {/* Email */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.emailLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={2}
                  autoFocus
                  type="email"
                  name="email"
                  value={currentClient?.email || ""}
                  placeholder={t("clients.emailLabel")}
                  onChange={handleEditClientChange}
                />
              </InputGroup>
              {/* Phone Number */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.phoneLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  minLength={5}
                  autoFocus
                  autoComplete="off"
                  type="text"
                  name="phoneNumber"
                  value={currentClient?.phoneNumber || ""}
                  placeholder={t("clients.phoneLabel")}
                  onChange={handleEditClientChange}
                />
              </InputGroup>
              {/* Country */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.countryLabel")}</InputGroup.Text>
                <Form.Control
                  autoFocus
                  type="text"
                  name="country"
                  value={currentClient?.country || ""}
                  placeholder={t("clients.countryLabel")}
                  onChange={handleEditClientChange}
                />
              </InputGroup>
              {/* State */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.stateLabel")}</InputGroup.Text>
                <Form.Control
                  autoFocus
                  type="text"
                  name="state"
                  value={currentClient?.state || ""}
                  placeholder={t("clients.stateLabel")}
                  onChange={handleEditClientChange}
                />
              </InputGroup>
              {/* Address */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.addressLabel")}</InputGroup.Text>
                <Form.Control
                  required
                  autoFocus
                  type="text"
                  name="address"
                  value={currentClient?.address || ""}
                  placeholder={t("clients.addressLabel")}
                  onChange={handleEditClientChange}
                />
              </InputGroup>

              {/* Image */}
              <InputGroup className="mb-3">
                <InputGroup.Text>{t("clients.imageLabel")}</InputGroup.Text>
                <Form.Control
                  minLength={3}
                  autoFocus
                  type="file"
                  name="image"
                  ref={fileInputRef}
                  placeholder={t("clients.imageLabel")}
                  onChange={handleFileRead}
                />
              </InputGroup>
              {/* Status */}
              <Form.Group>
                <Form.Label>{t("clients.statusLabel")}</Form.Label>
                <div className="switch d-inline m-r-10">
                  <Form.Control
                    type="checkbox"
                    id="checked-default"
                    name="status"
                    defaultChecked={clientActiveEditSwitch}
                    onChange={toggleClientActiveEditHandler}
                  />
                  <Form.Label htmlFor="checked-default" className="cr" />
                </div>
              </Form.Group>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseEditClient}>
              {t("common.close")}
            </Button>
            <Button variant="primary" type="submit">
              {t("common.save")}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <Modal show={showDeleteConfirm} onHide={handleCloseDeleteConfirm}>
        <Modal.Header closeButton>
          <Modal.Title>{t("common.confirmDeleteTitle")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t("clients.deleteClientConfirmMessage")}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteConfirm}>
            {t("common.cancel")}
          </Button>
          <Button variant="danger" onClick={deleteCliente}>
            {t("common.delete")}
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};
